import * as types from '../../mutation-types'
import * as service from '@/service/httpService'
import cookie from 'vue-cookie'
// initial state

const state = {
  userInfo: null,
  historyUserInfo: {}
}

// getters
const getters = {
  userInfo: state => state.userInfo,
  getUserInfo: state => state.userInfo
}

// actions
const actions = {
  // 加载用户数据
  getUserInfo: function ({ commit }) {
    return service.accountService
      .getUserInfo()
      .then(function (response) {
        commit('SET_USERINFO', response.data)
        cookie.set('userInfo', JSON.stringify(response.data))
      })
      .catch(function () {
        // window.location.reload(true)
      })
  },
  getHistoryInfo ({ commit }) {
    return service.userService
      .getUserInfo()
      .then(function (response) {
        commit('SET_HISTORY_USERINFO', response.data)
      })
      .catch(function () {
        // window.location.reload(true)
      })
  }
}

// mutations
const mutations = {
  [types.SET_USERINFO] (state, userInfo) {
    state.userInfo = userInfo
  },
  [types.SET_HISTORY_USERINFO] (state, userInfo) {
    state.historyUserInfo = userInfo
  },
  [types.DEL_USERINFO] (state) {
    state.userInfo = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/account/account.js